/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Nohraclinic API
 * API do Nohraclinic. Sessão web por cookie httpOnly; mobile por bearer. As rotas sob /v1/auth/* que não estão aqui são servidas pelo handler do better-auth, restrito a uma allowlist (ver src/modules/auth/auth.mount.ts): sign-in/email, sign-out, get-session, verify-email, send-verification-email, request-password-reset e reset-password. O cadastro entra só por POST /v1/auth/registro.
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CatalogoFarmacoDetalheResponse,
  CatalogoFarmacosConsultaControllerListarParams,
  CatalogoFarmacosConsultaControllerProdutosDeMedicamentoParams,
  ErroResponse,
  FarmacoSugeridoResponse,
  PaginaDeCatalogoFarmacosResponse,
  ProdutosDeMedicamentoResponse,
  SugerirFarmacoDto
} from '../model';

import { httpClient } from '../../http-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getCatalogoFarmacosConsultaControllerListarUrl = (params?: CatalogoFarmacosConsultaControllerListarParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/catalogo-farmacos?${stringifiedParams}` : `/v1/catalogo-farmacos`
}

/**
 * @summary Lista os fármacos ATIVOS, para escolher o princípio ativo ao montar um tratamento. A busca casa nome, sinônimo e nome comercial.
 */
export const catalogoFarmacosConsultaControllerListar = async (params?: CatalogoFarmacosConsultaControllerListarParams, options?: Parameters<typeof httpClient>[1]): Promise<PaginaDeCatalogoFarmacosResponse> => {

  return httpClient<PaginaDeCatalogoFarmacosResponse>(getCatalogoFarmacosConsultaControllerListarUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCatalogoFarmacosConsultaControllerListarQueryKey = (params?: CatalogoFarmacosConsultaControllerListarParams,) => {
    return [
    `/v1/catalogo-farmacos`, ...(params ? [params] : [])
    ] as const;
    }


export const getCatalogoFarmacosConsultaControllerListarQueryOptions = <TData = Awaited<ReturnType<typeof catalogoFarmacosConsultaControllerListar>>, TError = ErroResponse>(params?: CatalogoFarmacosConsultaControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoFarmacosConsultaControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCatalogoFarmacosConsultaControllerListarQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof catalogoFarmacosConsultaControllerListar>>> = ({ signal }) => catalogoFarmacosConsultaControllerListar(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof catalogoFarmacosConsultaControllerListar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CatalogoFarmacosConsultaControllerListarQueryResult = NonNullable<Awaited<ReturnType<typeof catalogoFarmacosConsultaControllerListar>>>
export type CatalogoFarmacosConsultaControllerListarQueryError = ErroResponse


export function useCatalogoFarmacosConsultaControllerListar<TData = Awaited<ReturnType<typeof catalogoFarmacosConsultaControllerListar>>, TError = ErroResponse>(
 params: undefined |  CatalogoFarmacosConsultaControllerListarParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoFarmacosConsultaControllerListar>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof catalogoFarmacosConsultaControllerListar>>,
          TError,
          Awaited<ReturnType<typeof catalogoFarmacosConsultaControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCatalogoFarmacosConsultaControllerListar<TData = Awaited<ReturnType<typeof catalogoFarmacosConsultaControllerListar>>, TError = ErroResponse>(
 params?: CatalogoFarmacosConsultaControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoFarmacosConsultaControllerListar>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof catalogoFarmacosConsultaControllerListar>>,
          TError,
          Awaited<ReturnType<typeof catalogoFarmacosConsultaControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCatalogoFarmacosConsultaControllerListar<TData = Awaited<ReturnType<typeof catalogoFarmacosConsultaControllerListar>>, TError = ErroResponse>(
 params?: CatalogoFarmacosConsultaControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoFarmacosConsultaControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista os fármacos ATIVOS, para escolher o princípio ativo ao montar um tratamento. A busca casa nome, sinônimo e nome comercial.
 */

export function useCatalogoFarmacosConsultaControllerListar<TData = Awaited<ReturnType<typeof catalogoFarmacosConsultaControllerListar>>, TError = ErroResponse>(
 params?: CatalogoFarmacosConsultaControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoFarmacosConsultaControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCatalogoFarmacosConsultaControllerListarQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCatalogoFarmacosConsultaControllerSugerirUrl = () => {




  return `/v1/catalogo-farmacos`
}

/**
 * @summary Cria um fármaco a partir do que o clínico digitou, marcado como SUGERIDO_PELO_CLINICO. Se já existir item com o mesmo nome ou sinônimo (acento/caixa-insensível), devolve o EXISTENTE com `reaproveitado: true` em vez de duplicar.
 */
export const catalogoFarmacosConsultaControllerSugerir = async (sugerirFarmacoDto: SugerirFarmacoDto, options?: Parameters<typeof httpClient>[1]): Promise<FarmacoSugeridoResponse> => {

  return httpClient<FarmacoSugeridoResponse>(getCatalogoFarmacosConsultaControllerSugerirUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sugerirFarmacoDto)
  }
);}





export const getCatalogoFarmacosConsultaControllerSugerirMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogoFarmacosConsultaControllerSugerir>>, TError,{data: SugerirFarmacoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof catalogoFarmacosConsultaControllerSugerir>>, TError,{data: SugerirFarmacoDto}, TContext> => {

const mutationKey = ['catalogoFarmacosConsultaControllerSugerir'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof catalogoFarmacosConsultaControllerSugerir>>, {data: SugerirFarmacoDto}> = (props) => {
          const {data} = props ?? {};

          return  catalogoFarmacosConsultaControllerSugerir(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CatalogoFarmacosConsultaControllerSugerirMutationResult = NonNullable<Awaited<ReturnType<typeof catalogoFarmacosConsultaControllerSugerir>>>
    export type CatalogoFarmacosConsultaControllerSugerirMutationBody = SugerirFarmacoDto
    export type CatalogoFarmacosConsultaControllerSugerirMutationError = ErroResponse

    /**
 * @summary Cria um fármaco a partir do que o clínico digitou, marcado como SUGERIDO_PELO_CLINICO. Se já existir item com o mesmo nome ou sinônimo (acento/caixa-insensível), devolve o EXISTENTE com `reaproveitado: true` em vez de duplicar.
 */
export const useCatalogoFarmacosConsultaControllerSugerir = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogoFarmacosConsultaControllerSugerir>>, TError,{data: SugerirFarmacoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof catalogoFarmacosConsultaControllerSugerir>>,
        TError,
        {data: SugerirFarmacoDto},
        TContext
      > => {
      return useMutation(getCatalogoFarmacosConsultaControllerSugerirMutationOptions(options), queryClient);
    }
    export const getCatalogoFarmacosConsultaControllerProdutosDeMedicamentoUrl = (params?: CatalogoFarmacosConsultaControllerProdutosDeMedicamentoParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/catalogo-farmacos/produtos?${stringifiedParams}` : `/v1/catalogo-farmacos/produtos`
}

/**
 * @summary Os produtos de parceiro da categoria Medicamento, cada um já CASADO contra o catálogo global. O tratamento grava o princípio ativo casado, nunca o produto.
 */
export const catalogoFarmacosConsultaControllerProdutosDeMedicamento = async (params?: CatalogoFarmacosConsultaControllerProdutosDeMedicamentoParams, options?: Parameters<typeof httpClient>[1]): Promise<ProdutosDeMedicamentoResponse> => {

  return httpClient<ProdutosDeMedicamentoResponse>(getCatalogoFarmacosConsultaControllerProdutosDeMedicamentoUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCatalogoFarmacosConsultaControllerProdutosDeMedicamentoQueryKey = (params?: CatalogoFarmacosConsultaControllerProdutosDeMedicamentoParams,) => {
    return [
    `/v1/catalogo-farmacos/produtos`, ...(params ? [params] : [])
    ] as const;
    }


export const getCatalogoFarmacosConsultaControllerProdutosDeMedicamentoQueryOptions = <TData = Awaited<ReturnType<typeof catalogoFarmacosConsultaControllerProdutosDeMedicamento>>, TError = ErroResponse>(params?: CatalogoFarmacosConsultaControllerProdutosDeMedicamentoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoFarmacosConsultaControllerProdutosDeMedicamento>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCatalogoFarmacosConsultaControllerProdutosDeMedicamentoQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof catalogoFarmacosConsultaControllerProdutosDeMedicamento>>> = ({ signal }) => catalogoFarmacosConsultaControllerProdutosDeMedicamento(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof catalogoFarmacosConsultaControllerProdutosDeMedicamento>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CatalogoFarmacosConsultaControllerProdutosDeMedicamentoQueryResult = NonNullable<Awaited<ReturnType<typeof catalogoFarmacosConsultaControllerProdutosDeMedicamento>>>
export type CatalogoFarmacosConsultaControllerProdutosDeMedicamentoQueryError = ErroResponse


export function useCatalogoFarmacosConsultaControllerProdutosDeMedicamento<TData = Awaited<ReturnType<typeof catalogoFarmacosConsultaControllerProdutosDeMedicamento>>, TError = ErroResponse>(
 params: undefined |  CatalogoFarmacosConsultaControllerProdutosDeMedicamentoParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoFarmacosConsultaControllerProdutosDeMedicamento>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof catalogoFarmacosConsultaControllerProdutosDeMedicamento>>,
          TError,
          Awaited<ReturnType<typeof catalogoFarmacosConsultaControllerProdutosDeMedicamento>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCatalogoFarmacosConsultaControllerProdutosDeMedicamento<TData = Awaited<ReturnType<typeof catalogoFarmacosConsultaControllerProdutosDeMedicamento>>, TError = ErroResponse>(
 params?: CatalogoFarmacosConsultaControllerProdutosDeMedicamentoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoFarmacosConsultaControllerProdutosDeMedicamento>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof catalogoFarmacosConsultaControllerProdutosDeMedicamento>>,
          TError,
          Awaited<ReturnType<typeof catalogoFarmacosConsultaControllerProdutosDeMedicamento>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCatalogoFarmacosConsultaControllerProdutosDeMedicamento<TData = Awaited<ReturnType<typeof catalogoFarmacosConsultaControllerProdutosDeMedicamento>>, TError = ErroResponse>(
 params?: CatalogoFarmacosConsultaControllerProdutosDeMedicamentoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoFarmacosConsultaControllerProdutosDeMedicamento>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Os produtos de parceiro da categoria Medicamento, cada um já CASADO contra o catálogo global. O tratamento grava o princípio ativo casado, nunca o produto.
 */

export function useCatalogoFarmacosConsultaControllerProdutosDeMedicamento<TData = Awaited<ReturnType<typeof catalogoFarmacosConsultaControllerProdutosDeMedicamento>>, TError = ErroResponse>(
 params?: CatalogoFarmacosConsultaControllerProdutosDeMedicamentoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoFarmacosConsultaControllerProdutosDeMedicamento>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCatalogoFarmacosConsultaControllerProdutosDeMedicamentoQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCatalogoFarmacosConsultaControllerObterUrl = (id: string,) => {




  return `/v1/catalogo-farmacos/${id}`
}

/**
 * @summary Detalha um fármaco com as apresentações comerciais. Item DESATIVADO continua legível — tratamento antigo aponta para ele e a tela precisa mostrar o nome.
 */
export const catalogoFarmacosConsultaControllerObter = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<CatalogoFarmacoDetalheResponse> => {

  return httpClient<CatalogoFarmacoDetalheResponse>(getCatalogoFarmacosConsultaControllerObterUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCatalogoFarmacosConsultaControllerObterQueryKey = (id: string,) => {
    return [
    `/v1/catalogo-farmacos/${id}`
    ] as const;
    }


export const getCatalogoFarmacosConsultaControllerObterQueryOptions = <TData = Awaited<ReturnType<typeof catalogoFarmacosConsultaControllerObter>>, TError = ErroResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoFarmacosConsultaControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCatalogoFarmacosConsultaControllerObterQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof catalogoFarmacosConsultaControllerObter>>> = ({ signal }) => catalogoFarmacosConsultaControllerObter(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof catalogoFarmacosConsultaControllerObter>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CatalogoFarmacosConsultaControllerObterQueryResult = NonNullable<Awaited<ReturnType<typeof catalogoFarmacosConsultaControllerObter>>>
export type CatalogoFarmacosConsultaControllerObterQueryError = ErroResponse


export function useCatalogoFarmacosConsultaControllerObter<TData = Awaited<ReturnType<typeof catalogoFarmacosConsultaControllerObter>>, TError = ErroResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoFarmacosConsultaControllerObter>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof catalogoFarmacosConsultaControllerObter>>,
          TError,
          Awaited<ReturnType<typeof catalogoFarmacosConsultaControllerObter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCatalogoFarmacosConsultaControllerObter<TData = Awaited<ReturnType<typeof catalogoFarmacosConsultaControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoFarmacosConsultaControllerObter>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof catalogoFarmacosConsultaControllerObter>>,
          TError,
          Awaited<ReturnType<typeof catalogoFarmacosConsultaControllerObter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCatalogoFarmacosConsultaControllerObter<TData = Awaited<ReturnType<typeof catalogoFarmacosConsultaControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoFarmacosConsultaControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Detalha um fármaco com as apresentações comerciais. Item DESATIVADO continua legível — tratamento antigo aponta para ele e a tela precisa mostrar o nome.
 */

export function useCatalogoFarmacosConsultaControllerObter<TData = Awaited<ReturnType<typeof catalogoFarmacosConsultaControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoFarmacosConsultaControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCatalogoFarmacosConsultaControllerObterQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






